import React, { Component } from 'react';

import DefaultGuy from './svgDataComponents/DefaultGuy.js';
import PencilIcon from './svgDataComponents/PencilSvg.js';
import AddIcon from './svgDataComponents/AddSvg.js';
import Circle from './svgDataComponents/Circle.js';
import SubmitIcon from './svgDataComponents/SubmitIcon.js';
import CancelIcon from './svgDataComponents/CancelIcon.js';
import ArrowUp from './svgDataComponents/ArrowUp.js';
import ArrowLeft from './svgDataComponents/ArrowLeft.js';
import ArrowRight from './svgDataComponents/ArrowRight.js';
import ArrowDown from './svgDataComponents/ArrowDown.js';
import FacedHeart from './svgDataComponents/FacedHeart.js';
import HeartBreak from './svgDataComponents/HeartBreak.js';
import InfoIcon from './svgDataComponents/InfoIcon.js';
import Search from './svgDataComponents/Search.js';
import Sort from './svgDataComponents/SortIcon.js';
import TwitterIcon from './svgDataComponents/TwitterIcon.js';
import LineIcon from './svgDataComponents/LineIcon.js';
import FacebookIcon from './svgDataComponents/FacebookIcon.js';
import ThanksCard from './svgDataComponents/ThanksCard.js';


export default class SvgIconBaseComponent extends Component {
    constructor(props){
        super(props)
        this.state = {
            svgStyle:{
                fillRule:'evenodd',
                clipRule:'evenodd',
                strokeLinejoin:'round',
                strokeMiterlimit:1.41421,
            },
            svgComponents:[
                {component:null,image:'none'},
                {component:DefaultGuy,image:'defaultGuy'},
                {component:PencilIcon,image:'pencil'},
                {component:AddIcon,image:'add'},
                {component:SubmitIcon,image:'submit'},
                {component:Circle,image:'circle'},
                {component:CancelIcon,image:'cancel'},
                {component:ArrowUp,image:'arrowUp'},
                {component:ArrowLeft,image:'arrowLeft'},
                {component:ArrowRight,image:'arrowRight'},
                {component:ArrowDown,image:'arrowDown'},
                {component:FacedHeart,image:'facedHeart'},
                {component:HeartBreak,image:'heartBreak'},
                {component:InfoIcon,image:'info'},
                {component:Search,image:'search'},
                {component:Sort,image:'sort'},
                {component:TwitterIcon,image:'twitter'},
                {component:LineIcon,image:'line'},
                {component:FacebookIcon,image:'facebook'},
                {component:ThanksCard,image:'thanksCard'},
            ],

            
        }
    }

    render(){
      
        //propsに入力されたものからコンポーネントを選択
        const svgComponent = (value) => {
            return (
                value.image === this.props.image
                && value.image !== 'none'
                ? React.createElement(
                    value.component,
                    { svgStyle:this.state.svgStyle,fillColor:this.props.fillColor,key:value.image }
                )
                : null
            )
        }

        const customStyle = {lineHeight:0}

        return (
            <div style={customStyle}>
              {this.state.svgComponents.map(svgComponent)}
            </div>
        )
    }
}

// Propsのデフォルト値
SvgIconBaseComponent.defaultProps = {
    image:'none',
    fillColor: 'transparent',
};
